import React from 'react'
import { Box, Text } from 'front-end/src/components'
import { t, Trans } from '@lingui/macro'
import { useLooopTheme } from '../../../public-api/hooks/useLooopTheme'
import NoMobileSupport from 'public/assets/img/no-mobile-support.svg'

const ActivityHistoryMobileBlockerScreen = () => {
  const { theme } = useLooopTheme()

  return (
    <Box mt="120px">
      <Box
        backgroundImage={NoMobileSupport}
        aria-label={t`No mobile support`}
        backgroundRepeat="no-repeat"
        backgroundPosition="center"
        h="109px"
      />
      <Text mt="36px" color={theme.colors.grey['500']} align="center">
        <Trans>
          This feature is not available on this device. Please use a desktop
          device.
        </Trans>
      </Text>
    </Box>
  )
}

export default ActivityHistoryMobileBlockerScreen
